// libs
import React, { memo } from 'react';

// components

// constants
import { SHEET_TRANSITION, useOverlaySheetContext } from 'shared/components/OverlaySheet';

// styles
import { ImageContainer, Title, Content, Container, Image, SecondaryButton } from './styles';

// defs
interface DescriptionProps {
  imageUrl: string;
  label: string;
  description: string;
  onHide: VoidFunction;
}

const NAV_KEY = 'responsible-tag-popup';

const IMAGE_DIMENSION = {
  WIDTH: 56,
  HEIGHT: 56,
  ASPECT_RATIO: 1,
};

function Description({ imageUrl, label, description, onHide }: DescriptionProps) {
  const DescriptionContent = () => {
    const { doHide } = useOverlaySheetContext();

    return (
      <>
        <ImageContainer>
          <Image
            src={imageUrl}
            alt={label}
            width={IMAGE_DIMENSION.WIDTH}
            height={IMAGE_DIMENSION.HEIGHT}
            aspectRatio={IMAGE_DIMENSION.ASPECT_RATIO}
            placeholderColor="transparent"
          />
        </ImageContainer>
        <Title>{label}</Title>
        <Content>{description}</Content>
        <SecondaryButton onClick={doHide}>Okay</SecondaryButton>
      </>
    );
  };

  return (
    <Container onHide={onHide} navKey={NAV_KEY} transitionFrom={SHEET_TRANSITION.BOTTOM}>
      <DescriptionContent />
    </Container>
  );
}

export default memo(Description);
